import { useCallback } from "react";
import { ContextValue } from "components/bookShuffle/useBookShuffle/types";

export default function useOwnsBook(context: ContextValue) {
  const { dispatch, stateRef } = context;

  context.toggleOwnsBook = useCallback(() => {
    const { currentIndex, books } = stateRef.current;
    const ownsBook = !Boolean(books[currentIndex].ownsBook);
    dispatch({
      type: "ownsBook",
      payload: {
        ownsBook,
      },
    });
  }, [dispatch, stateRef]);
}
